import { createPortal } from 'react-dom'

const ReferralTermsModal = ({ onClose }: { onClose: () => void }) => {
  return createPortal(
    <div id="modal-example" className="pf-modal">
      <div className="pf-modal__dialog">
        <div className="pf-modal__content">
          <div className="pf-modal__body">
            <div className="pf-page__logo">
              <div className="pf-page__logo-content">
                <img
                  src='/logo.png'
                  alt='AllFans'
                  className='pf-page__logo-img'
                />
              </div>
            </div>
            <h2 className="pf-page__title">
              All<span>Fans</span>
            </h2>
            <div className="pf-page__descr">Referral Program Terms</div>
          <div className="pf-content__description">
            <p>
              These referral program terms are additional terms that apply if you use the 
              AllFans referral program (“AllFans Referral Program”). 
              These referral program terms form part of your agreement with us.
            </p>
          </div>
                    <ol className="pf-main-list">
            <li>
              <h5>Definitions</h5>
              <p>In these referral program terms, defined terms have the same 
                meanings given to them in the <a href='/creatorterms' className='terms-link'>Creator Terms</a>. In addition:</p>
              <p>
                <strong>“Referred Creator”</strong> means the person who joins 
                AllFans as a Creator through the Referring User’s unique referral link.
              </p>
              <p>
                <strong>“Referring User”</strong> means “you” or “your.”
              </p>
            </li>
            <li>  
              <h5>AllFans Referral Program</h5>
              <p>
                AllFans offers a referral program by which existing Users can 
                introduce people who are interested in becoming Creators on AllFans 
                and receive referral payments from AllFans that are calculated and 
                limited as described in these terms.
              </p>
            </li>
            <li>
              <h5>AllFans Referral Program Rules</h5>
                <ol>
                  <li>
                    Only Users of AllFans with a current User account can participate 
                    in the AllFans Referral Program. If a User’s account has been suspended 
                    or terminated by us for any reason or deleted by the User, that User will not be eligible 
                    to participate in the AllFans Referral Program.
                  </li>
                  <li>
                    You will need to add on your User account page payment method details to receive 
                    referral payments under the AllFans Referral Program.
                  </li>
                  <li>
                    Each User has a unique referral link (which can be accessed through the User’s User 
                    account) that the User may share with others. When sharing your unique referral link, 
                    you must not impersonate AllFans or give the impression that your referral 
                    link is being shared or promoted by us. You must not use Google Ads or any similar 
                    advertising platform or search engine advertising service to share or promote your unique 
                    referral link. On our request, you must disclose the methods by which you share your 
                    unique referral link in the Bio/Website field of your AllFans account.
                  </li>
                  <li>
                    The Referred Creator must click on your unique referral link and then register with 
                    AllFans using the same browser that they used to click on your unique referral link. 
                    If someone registers with AllFans other than by using your unique referral link, we 
                    will not link that account to your referral and no referral payments will be made to you.
                  </li>
                  <li>
                    The Referred Creator must not have opened a User account with AllFans (whether 
                    under the same name or another name) before clicking on your unique referral link. If the 
                    Referred Creator is currently or has previously been a User of AllFans, no 
                    referral payments will be made to you for the referral.
                  </li>
                  <li>
                    If the Referred Creator sets up more than one User account, we will make referral 
                    payments to you on the earnings made by the Referred Creator from their first User 
                    account only. No referral payments will be made to you on any further User accounts set 
                    up by the Referred Creator.
                  </li>
                  <li>
                    We will not pay any referral payments to you on any referral of a Referred Creator 
                    that we determine is owned or operated by you or is in a commercial relationship with you. 
                    You will provide any information that we request to allow us to determine whether the 
                    Referred Creator is owned or operated by you or if there is a commercial relationship 
                    between you and the Referred Creator.
                  </li>
                  <li>
                    When promoting AllFans in any way as a Referring User:
                      <ul>
                        <li>
                          you must not give a false impression of AllFans, the services, programs, 
                          and content (including Content) made available through AllFans, its Users, 
                          or the <a href='/terms' className='terms-link'>Terms of Service</a>; and
                        </li>
                        <li>
                          you must not make any statements that suggest to a potential Creator that the 
                          potential Creator will make a particular sum of money (or any money) from their 
                          use of AllFans, or any statements regarding the likely number of Fans.
                        </li>
                      </ul>
                  </li>
                </ol>
              </li>
              <li>
                <h5>AllFans Referral Program Rules</h5>
                <ul>
                  <li>
                    Once a Referred Creator has become a registered User of AllFans in 
                    accordance with the rules of the AllFans Referral Program, we will pay the 
                    Referring User 5% of Fan Payments generated by the Referred Creator in the 12 months after 
                    the date on which the Referred Creator becomes a registered User of AllFans, 
                    up to a maximum referral payment by AllFans to the Referring User of $75,000 
                    for each Referred Creator.
                  </li>
                  <li>
                    All referral payments payable to Referring Users by us are inclusive of any Taxes.
                  </li>
                  <li>
                    To receive referral payments, you must first choose one of the payout methods 
                    provided by AllFans in your country of residence.
                  </li>
                  <li>
                    The referral payments due to you on Fan Payments made to the Referred Creator in a 
                    calendar month will be transferred to you on or around the first day of the next calendar 
                    month (which means, for example, that referral payments due to you for Fan Payments made 
                    to the Referred Creator in May will be paid to you on or around June 1).
                  </li>
                  <li>
                    Once a Referred Creator has become a registered User of AllFans in 
                    accordance with the rules of the AllFans Referral Program, we will pay the 
                    Referring User 5% of Fan Payments generated by the Referred Creator in the 12 months after 
                    the date on which the Referred Creator becomes a registered User of AllFans, 
                    up to a maximum referral payment by AllFans to the Referring User of $75,000 
                    for each Referred Creator.
                  </li>
                  <li>
                    AllFans, not the Referred Creator, bears the cost of the referral payment.
                  </li>
                </ul>
              </li>
              <li>
                <h5>AllFans’s Rights relating to the Referral Program</h5>
                <ul>
                  <li>
                    If referral payments have been made incorrectly, we may recover the wrongly paid 
                    sums from the User to whom the wrongly paid sums have been paid.
                  </li>
                  <li>
                    We may request you or Referred Creators or both to provide us with ID 
                    and other information reasonably required by us to verify any referral payment to be 
                    made and the person to whom any referral payment should be made. Failure to provide 
                    any information requested by us may lead to you losing your entitlement to referral 
                    payments for the relevant Referred Creator.
                  </li>
                  <li>
                    We may change any aspect of the AllFans Referral Program (including 
                    how referral payments are calculated) or discontinue the AllFans Referral 
                    Program at any time, but no change will deprive any Referring User of referral payments 
                    already earned based on Fan Payments made to Referred Creators before the changes take effect.
                  </li>
                </ul>
              </li>
              <li>
                <h5>Right to Withhold Referral Payments</h5>
                <ul>
                  <li>
                    We may withhold any part of the referral payments due to you but not yet paid out: 
                    (1) if we think that you have or might have materially or repeatedly breached any part of 
                    the <a href='/terms' className='terms-link'>Terms of Service</a> or <a href='/creatorterms' className='terms-link'>Creator Terms</a>; (2) if you attempt or threaten to breach any 
                    part of the <a href='/terms' className='terms-link'>Terms of Service</a> or <a href='/creatorterms' className='terms-link'>Creator Terms</a> in a way that has or could have serious 
                    consequences for us or another User (including actual or possible loss caused to us or 
                    another User); or (3) if we suspect that any part of the referral payments due to you result 
                    from unlawful or fraudulent activity, either by you, by the Fan who made the Fan Payment to 
                    the Referred Creator that resulted in the referral payment, or by the Referred Creator to 
                    whom the Fan Payment was made that resulted in the referral payment, for as long as is 
                    necessary to investigate the actual, threatened, or suspected breach(es) by you or the 
                    suspected unlawful or fraudulent activity (as applicable). If after our investigation, we 
                    conclude that (1) you have materially or repeatedly breached any part of the <a href='/terms' className='terms-link'>Terms of Service</a> or <a href='/creatorterms' className='terms-link'>Creator Terms</a>; (2) you have attempted or threatened to breach any part of 
                    the <a href='/terms' className='terms-link'>Terms of Service</a> or <a href='/creatorterms' className='terms-link'>Creator Terms</a> in a way that has or could have serious 
                    consequences for us or another User (including actual or possible loss caused to us or 
                    another User); or (3) any part of referral payments due to you result from unlawful or 
                    fraudulent activity, we may notify you that you have forfeited all or part of your referral 
                    payments.
                  </li>
                  <li>
                    We may also withhold all or part of the referral payments due to you but not yet paid out 
                    if we receive notice that you have secured, encumbered, pledged, assigned, or otherwise allowed 
                    a lien to be placed on, referral payments. We are not required to pay referral payments to 
                    nonparty lienholders and may withhold payment of Creator Earnings until the lien has been 
                    removed.
                  </li>
                  <li>
                    We are not liable to you if we withhold or forfeit any payment due to you under the 
                    AllFans Referral Program where we have a right to do so under these terms.
                  </li>
                  <li>
                    If we are withholding all or part of the referral payments due to you and we determine 
                    that part of the referral payments withheld by us is unrelated to breaches by you of the 
                    <a href='/terms' className='terms-link'>Terms of Service</a> or <a href='/creatorterms' className='terms-link'>Creator Terms</a> or suspected unlawful or fraudulent activity, then 
                    we may arrange for you to be paid the part of the referral payments that is unrelated to 
                    breaches by you of the <a href='/terms' className='terms-link'>Terms of Service</a> or <a href='/creatorterms' className='terms-link'>Creator Terms</a> or suspected unlawful or 
                    fraudulent activity. But if we consider that your breaches of the <a href='/terms' className='terms-link'>Terms of Service</a> or <a href='/creatorterms' className='terms-link'>Creator Terms</a> has or might cause us loss, we may withhold all referral payments due 
                    to you but not yet paid and we may set off those amounts against any losses suffered by us.
                  </li>
                </ul>
              </li>
            </ol>
          </div>  
        </div>
          <div className="pf-modal__footer">
            <div className="pf-page__social">
              <button
                type="button"
                onClick={onClose}
                className="btn btn-default"
                style={{
                  width: '100%',
                  maxWidth: '220px'
                }}
              >
                Close
              </button>
            </div>
          </div>
      </div>
    </div>, document.body
  )
}

export default ReferralTermsModal
